export default "__VITE_ASSET__BfIjAtMx__"